import React, { useEffect, useState, useRef } from 'react';
import {useNavigate} from 'react-router-dom';
import Sidebar from '../Sidebar';
import axios from 'axios'
// import env from 'react-dotenv'
import {optionProductsByProducts, category, tags} from '../Options';
import Multiselect from 'multiselect-react-dropdown';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import Font from '@ckeditor/ckeditor5-font/src/font';
// ClassicEditor.builtinPlugins.push(Font);


const editorConfiguration = {
  toolbar: [
    'heading',
    '|',
    'bold',
    'italic',
    'fontColor',  // Add font color
    'fontBackgroundColor', // (optional) Add font background color
    '|',
    'link',
    'bulletedList',
    'numberedList',
    '|',
    'undo',
    'redo'
  ],
  fontColor: {
    colors: [
      {
        color: 'hsl(0, 0%, 0%)',
        label: 'Black'
      },
      {
        color: 'hsl(0, 0%, 30%)',
        label: 'Dim grey'
      },
      {
        color: 'hsl(0, 0%, 60%)',
        label: 'Grey'
      },
      {
        color: 'hsl(0, 0%, 90%)',
        label: 'Light grey'
      },
      {
        color: 'hsl(0, 0%, 100%)',
        label: 'White',
        hasBorder: true
      },
      {
        color: 'hsl(0, 75%, 60%)',
        label: 'Red'
      },
      {
        color: 'hsl(30, 75%, 60%)',
        label: 'Orange'
      },
      {
        color: 'hsl(60, 75%, 60%)',
        label: 'Yellow'
      },
      {
        color: 'hsl(90, 75%, 60%)',
        label: 'Light green'
      },
      {
        color: 'hsl(120, 75%, 60%)',
        label: 'Green'
      }
    ]
  }
};

export default function NewsInput() {
    {/**Images states */}
    const [files, setFiles] = useState([]);
    const [filenames, setFilenames] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [message, setMessage] = useState('');
    const [imagePreviews, setImagePreviews] = useState([]);

    //province items
    const [options, setOptions] = useState([])
    const [options2, setOptions2] = useState([])
    //options
    const [selectedOptions, setSelectedOptions] = useState([])
    const [selectedOptions2, setSelectedOptions2] = useState([])

    const ref1 = useRef()
    const ref2 = useRef()
    const ref3 = useRef()
    const ref4 = useRef()
    const ref5 = useRef()
    const ref6 = useRef()
    const ref7 = useRef()

    const nav = useNavigate()

    const [form, setForm] = useState({
        postTitle:'',
        postLink: '',
        postBody:'',
        postExcerpt:'',
        postCategory:[],
        postTags:[],
        postAuthor:'',
        postCreated:'',
        images: [],
    })

    useEffect(()=>{
        setOptions(tags)
        setOptions2(category)
    }, [])


      const navigateToBlogs = () =>{
        nav('/news')
      }


      const onSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('form', JSON.stringify(form));
       // console.log("Here is the form that I am submitting ", form)
        for (let i = 0; i < files.length; i++) {
          formData.append('files', files[i]);
        }
  
        try {
          const res = await axios.post(`${process.env.REACT_APP_API_URL}/upload-news`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            data: form
          });
  
          const newUploadedFiles = res.data;
          setUploadedFiles(newUploadedFiles);
          setMessage('Files Uploaded');
          // reset()
          navigateToBlogs()
         // console.log("This is the ", res.data)
        } catch (err) {
          if (err.response.status === 500) {
            setMessage('There was a problem with the server');
           // console.log("meh")
          } else {
            setMessage(err.response.data.msg);
           // console.log("meh2")
          }
        }
      };
  
     useEffect(()=>{
       // console.log(form)
      },[form])

      const onChange = (e) => {
        const selectedFiles = Array.from(e.target.files); 
        const selectedFilenames = selectedFiles.map((file) => file.name);
        
        const newImageObjects = selectedFiles.map((file) => ({
          img_url: `${process.env.REACT_APP_API_URL}/news/${file.name}`, 
          img_path: '/news/',
        }));
      
        // Ensure that only one image is uploaded
        if (files.length === 0) {
          setFiles(selectedFiles);
          setFilenames(selectedFilenames);
          setForm((prevObject) => ({
            ...prevObject,
            images: newImageObjects,
          }));
        } else {
          alert("Only one image can be uploaded.");
        }
      
        const previews = selectedFiles.map((file) => {
          const reader = new FileReader();
          return new Promise((resolve) => {
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsDataURL(file);
          });
        });
      
        Promise.all(previews).then((previewData) => {
          setImagePreviews([...imagePreviews, ...previewData]);
        });
      };
      


      const organizeImagesIntoRows = () => {
        const rows = [];
        for (let i = 0; i < imagePreviews.length; i += 3) {
          const row = imagePreviews.slice(i, i + 3);
          rows.push(row);
        }
        return rows;
      };
 
      const addImageInput = () => {
        if (files.length > 0) {
          // Display a message or simply prevent adding a new input
          alert("Only one image can be uploaded. Please remove the current image before uploading a new one.");
          return;
        }
        
        const input = document.createElement('input');
        input.type = 'file';
        input.className = 'custom-file-input';
        input.required = true;
        input.multiple = false;
        input.addEventListener('change', onChange);
        input.click();
      };
      
  
      const onDeleteImage = (index) => {
        const newFiles = [...files];
        const newFilenames = [...filenames];
        const newImagePreviews = [...imagePreviews];
        newFiles.splice(index, 1);
        newFilenames.splice(index, 1);
        newImagePreviews.splice(index, 1);
        setFiles(newFiles);
        setFilenames(newFilenames);
        setImagePreviews(newImagePreviews);
      };


    //dealing with multiple states
    const handleSelectStateOptions =  (selectedList)=>{
      setSelectedOptions(selectedList)
    }
    useEffect(()=>{
      setForm({...form, postTags: selectedOptions})
    },[selectedOptions])

    const handleSelectStateOptions2 =  (selectedList)=>{
      setSelectedOptions2(selectedList)
    }
    useEffect(()=>{
      setForm({...form, postCategory: selectedOptions2})
    },[selectedOptions2])
  return (
<>

<div className="sidebar">
<Sidebar/>
</div>
    <div id="tabler">
        <h1>News</h1>
   <form onSubmit={onSubmit}>

   
<div >
    <label for="formGroupExampleInput2" class="form-label">Tag</label>
            <Multiselect 
              options={options}
              displayValue='name' 
              selectedValues={selectedOptions}
              onSelect={handleSelectStateOptions}
              onRemove={(selectedList) => {
                setSelectedOptions(selectedList);
            }}
              closeOnSelect={false}
              avoidHighlightFirstOption
            />
    </div>

    <div >
    <label for="formGroupExampleInput2" class="form-label">Category</label>
            <Multiselect 
              options={options2}
              displayValue='name' 
              selectedValues={selectedOptions2}
              onSelect={handleSelectStateOptions2}
              onRemove={(selectedList) => {
                setSelectedOptions2(selectedList);
            }}
              closeOnSelect={false}
              avoidHighlightFirstOption
            />
    </div>


<div className="row">
    <div className="col-md-6">
            {/**Post Title */}
    <label for="formGroupExampleInput" class="form-label">Title</label>
    <div class="input-group input-group-sm mb-3">
        <input required ref={ref1} onChange={e => setForm({...form, postTitle: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>

    <div className="col-md-6">
            {/**Post Author*/}
    <label for="formGroupExampleInput" class="form-label">Author</label>
    <div class="input-group input-group-sm mb-3">
        <input required ref={ref2} onChange={e => setForm({...form, postAuthor: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>
</div>

<div className="row">
    <div className="col-md-6">
    {/**Post Link */}
    <label for="formGroupExampleInput" class="form-label">Excerpt</label>
    <div class="input-group input-group-sm mb-3">
        <input ref={ref5} required onChange={e => setForm({...form, postExcerpt: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>

    <div className="col-md-6">

    {/**Post Link */}
    <label for="formGroupExampleInput" class="form-label">Link</label>
    <div class="input-group input-group-sm mb-3">
        <input ref={ref7} required onChange={e => setForm({...form, postLink: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>
</div>

<div className="row">
    <div className="col-md-6">
    {/**Post Creates */}
    <label for="formGroupExampleInput" class="form-label">Date</label>
    <div class="input-group input-group-sm mb-3">
        <input required ref={ref3} onChange={e => setForm({...form, postCreated: e.target.value})} type="date" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
    </div>
    </div>

</div>

{filenames.map((filename, index) => (
            <div key={index} className="custom-file mb-4">
              <input type="file" className="custom-file-input" id={`customFile-${index}`} style={{ display: 'none' }} />
              <label className="custom-file-label" htmlFor={`customFile-${index}`}>
                {filename}    
              </label>
              <button type="button" onClick={() => onDeleteImage(index)} style={{color:"white", backgroundColor:"red", border:"1px solid red", borderRadius:"3px"}}>x</button>
            </div>
          ))}
          <div className="row">
          <div className="col-md-3">
          <button type="button" className="btn btn-primary" onClick={addImageInput}>
            + Add Cover Photo 
          </button>
          </div>
          </div>

          <div className="row mt-4">
          {organizeImagesIntoRows().map((row, rowIndex) => (
            <div className="row" key={rowIndex}>
              {row.map((preview, index) => (
                  <div>
                  <img style={{ width: '100%' }} src={preview} alt="Image Preview" />
                  <p  className="text-center">{filenames[index]}</p>
                  </div>
              ))}
            </div>
            ))}
            </div>


    {/**Post Body */}
    <label for="formGroupExampleInput" class="form-label">Body </label>
    {/* <div class="input-group input-group-sm mb-3">
    <textarea ref={ref4}  onChange={e => setForm({...form, postBody: e.target.value})} class="form-control" id="num-value" ></textarea>
    </div> */}    <CKEditor
                    ref={ref4}
                    editor={ ClassicEditor }
                    config={editorConfiguration}
                    data="<p></p>"
                    onReady={ editor => {
                       // console.log( 'Editor is ready to use!', editor );
                    } }
                    onChange={ ( event, editor ) => {
                        const data = editor.getData();
                        setForm({...form, postBody: data})
                    } }
                    onBlur={ ( event, editor ) => {
                       // console.log( 'Blur.', editor );
                    } }
                    onFocus={ ( event, editor ) => {
                       // console.log( 'Focus.', editor );
                    } }
                />



          <button type="submit" class="btn submit-btn" style={{marginTop:"20px"}}>Submit</button>
    </form>

            
        {message ? <p>{message}</p> : null}
    </div>
</>
  );
}
